import  React, {useState, useEffect} from "react";

import { isNonEmptyArray, isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { searchOrganizations } from "utils";
import { api } from "services";

import FlowableFinder from "../Common/FlowableFinder";
import styles from "./styles.css";

const FlowableOrgSearch = (props) => {

	const [ preselectedOptions, setPreselectedOptions ] = useState();

	useEffect(()=> {
		if(props.config.value) {
			const promises = [];

			if(isNonEmptyArray(props.config.value)) {
				props.config.value.forEach(val => {
					if(isNonEmptyString(val)) {
						promises.push(api.organization.get({ id: val }));	
					}
				});
			} else if(isNonEmptyString(props.config.value)) {
				promises.push(api.organization.get({ id: props.config.value }));	
			}

			Promise.all(promises).then((results) => {
				const org = []
				results.forEach(data => {
					org.push({
						key: data.id,
						value: data.id,
						text: data.name,
						organization: {
							...data
						},
						content: (
							<div className="optionContent">
								<span>{data.name}</span>
							</div>
						),
					})
				});
	
				setPreselectedOptions(org);
			});
		} else {
			setPreselectedOptions(null);
		}
		
	}, [props.config.value]);
	
	const searchChange = (selectedOptions) => {
		setPreselectedOptions(selectedOptions);
		const values = isNonEmptyArray(selectedOptions) ? selectedOptions.map(option => option.organization.id) : null;
		props.onChange(values);
	};

	return (
		<div className={styles.flowableOrgSearch}>
			<FlowableFinder
				search={searchOrganizations}
				searchChange={searchChange}
				preselectedOptions={preselectedOptions}
				{...props}
			/>
		</div>
	)
}

export default FlowableOrgSearch;
